/**
 * version.js — Fuente única de la versión del OS mostrada en UI.
 *
 * Fuente: `VITE_APP_VERSION` inyectado en build (ver vite.config.js) desde
 * package.json. Todos los lugares que muestran versión (badge del logo,
 * footer del sidebar, sentry release, /api/version del backend) deben
 * derivar de acá — NUNCA hardcodear "OS X.Y" en un componente.
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "dev";
// Versión de producto que ve la gente (SOA 10 PRO). El número técnico (APP_VERSION) sigue
// siendo la referencia para comparar contra el backend y para Sentry: no se muestra.
export const VERSION_PRODUCTO = "10";
export const APP_ENV     = import.meta.env.VITE_APP_ENV     || "prod";

function parts() {
  const [maj = "0", min = "0", patch = "0"] = APP_VERSION.split(".");
  return { maj, min, patch };
}

/** Etiqueta corta para el badge del logo: "OS 8.3 PRO" */
export function osLabel() {
  const { maj, min } = parts();
  void maj; void min;
  return "SOA 10 PRO"; // SOA 10 PRO · nombre de producto (el número de versión técnica sigue en fullVersion)
}

/** Versión completa con prefijo v: "v8.3.3" o "v8.3.3 · canary" */
export function fullVersion() {
  return APP_ENV === "prod" ? `v${VERSION_PRODUCTO}` : `v${VERSION_PRODUCTO} · ${APP_ENV}`;
}

/** Solo "8.3.3" */
export function raw() {
  return APP_VERSION;
}
